import React from 'react'
import { Div } from "atomize";
import { Transition } from "react-transition-group";
import ReactPlayer from 'react-player'

const duration = 500;

const defaultStyle = {
  transition: `opacity ${duration}ms ease-in-out`,
  opacity: 0,
};

const transitionStyles = {
  entering: { opacity: 0 },
  entered: { opacity: 1 },
  exiting: { opacity: 0 },
  exited: { opacity: 0 },
};


export default function VideoModal({ isOpen, close }) {
  return (
    <Transition in={isOpen} timeout={duration} unmountOnExit>
      {(state) => (
        <>
          <Div
            style={{
              ...defaultStyle,
              ...transitionStyles[state],
            }}
            className="backdrop-blur"
            pos="fixed"
            top="0"
            left="0"
            right="0"
            bottom="0"
            bg="rgba(0,0,0,0.72)"
            zIndex="1000"
          />
          <Div
            style={{
              ...defaultStyle,
              ...transitionStyles[state],
            }}
            onClick={close}
            pos="fixed"
            d="flex"
            flexDir="column"
            align="center"
            justify="center"
            top="0"
            left="0"
            right="0"
            bottom="0"
            zIndex="1000"
          >
            <Div w="90%" maxW="900px" onClick={e => e.stopPropagation()}>
              <Div pos="relative" p={{ b: '56.25%' }}>
                <Div w="100%" h="100%" pos="absolute" top="0" left="0" top="50%" left="50%" transform="translate(-50%, -50%)">
                  <ReactPlayer
                    className="video-modal-video"
                    url="https://vimeo.com/562701448"
                    controls={true}
                  />
                </Div>
              </Div>
            </Div>
          </Div>
        </>
      )}
    </Transition>
  )
}
